var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-go-back-button row"
  }, [_c('button', {
    class: ['small-12 columns ugc-go-back-button-cta ugc-modal-button', {
      hide: _vm.hideButton
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.toggleBackButton
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n    < " + _vm._s(_vm.translations.ugcModalBack) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }